import { IBreadcrumbItem, Route, BreadcrumbItem } from './BreadcrumbItem';

//
export interface IBreadcrumb {
  key: string;
  items: IBreadcrumbItem[];
  extend(key: string, items: IBreadcrumbItem[]): IBreadcrumb;
  add(title: string, route: Route): IBreadcrumb;
}
export class Breadcrumb implements IBreadcrumb {
  constructor(public key: string, public items: IBreadcrumbItem[]) {}
  extend(key: string, items: IBreadcrumbItem[] = []) {
    const copy_items = this.items.map(i => i.copy());
    const merge_items = [...copy_items, ...items];
    return new Breadcrumb(key, merge_items);
  }
  add(title: string, route: Route) {
    const item = new BreadcrumbItem(title, route);
    this.items.push(item);
    return this;
  }
}
